import { useClubData } from '../lib/club-data.context';

/**
 * Hook to fetch the next fixture for the user's club
 * Uses the ClubDataContext to access centralized fixture data
 */
export const useNextFixture = () => {
  const { nextFixture, isLoading, error } = useClubData();
  
  return { 
    fixture: nextFixture,
    isLoading,
    error
  };
};